<script setup lang="ts">
import { computed } from 'vue'
import { formatMoney } from '@/shared/lib'
import { Alert } from '@/shared/ui/Alert'

import { useAccount } from '../model/useAccount'

const { paymentsUnderReview } = useAccount()

const detailsText = computed(() =>
  paymentsUnderReview.value
    .map(
      (payment) => `${payment.paymentSystem}: ${formatMoney(payment.amount)}`
    )
    .join(', ')
)
</script>

<template>
  <Alert
    v-if="paymentsUnderReview.length"
    type="success"
    effect="dark"
    title="Your payments are under review."
  >
    {{ detailsText }}. It may take up to 2 business days
  </Alert>
</template>
